<template>
	<div class="notice-wrap">
		<el-breadcrumb separator="/" class="path">
			<el-breadcrumb-item :to="{ path: '/' }" class="path-home">
				<i class="n el-icon-s-home"></i>
				首页
			</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/cms/notice' }">公告列表</el-breadcrumb-item>
			<el-breadcrumb-item class="path-help">公告详情</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="notice-detil" v-loading="loading">
			<div class="notice-info">
				<div class="title">{{ info.title }}</div>
				<div class="time">{{ $util.timeStampTurnTime(info.create_time) }}</div>
			</div>
			<div class="content" v-html="info.content"></div>
		</div>
	</div>
</template>

<script>
import { noticeDetail } from '@/api/cms/notice';
export default {
	name: 'notice_detail',
	components: {},
	data: () => {
		return {
			info: {},
			title: '热付通商城公告',
			content: `<p style=\"margin-top: 0px; margin-bottom: 16px; padding: 0px; line-height: 30px; color: rgb(153, 153, 153); font-family: Arial, Helvetica, &quot;Microsoft Yahei&quot;, 微软雅黑, &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;, Tahoma, STHeiti; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);\"><span style=\"color: rgb(0, 0, 0);\">尊敬的热付通用户：</span></p><p style=\"margin-top: 0px; margin-bottom: 16px; padding: 0px; line-height: 30px; color: rgb(153, 153, 153); font-family: Arial, Helvetica, &quot;Microsoft Yahei&quot;, 微软雅黑, &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;, Tahoma, STHeiti; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);\"><span style=\"color: rgb(0, 0, 0);\">经过多方不懈努力，平台已正式上线，感谢广大用户们的期待与支持！</span></p><p style=\"margin-top: 0px; margin-bottom: 16px; padding: 0px; line-height: 30px; color: rgb(153, 153, 153); font-family: Arial, Helvetica, &quot;Microsoft Yahei&quot;, 微软雅黑, &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;, Tahoma, STHeiti; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);\"><span style=\"color: rgb(0, 0, 0);\">商城系统主要功能有：&nbsp;&nbsp;</span></p><p style=\"margin-top: 0px; margin-bottom: 16px; padding: 0px; line-height: 30px; color: rgb(153, 153, 153); font-family: Arial, Helvetica, &quot;Microsoft Yahei&quot;, 微软雅黑, &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;, Tahoma, STHeiti; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);\"><span style=\"color: rgb(0, 0, 0);\">1、暖通服务<br/></span></p><p style=\"margin-top: 0px; margin-bottom: 16px; padding: 0px; line-height: 30px; font-family: Arial, Helvetica, &quot;Microsoft Yahei&quot;, 微软雅黑, &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;, Tahoma, STHeiti; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);\">本平台提供专业的暖通服务，拥有丰富经验的暖通团队及签约服务商，致力于为您提供优质的暖通服务，打造温暖的家。</p><p style=\"margin-top: 0px; margin-bottom: 16px; padding: 0px; line-height: 30px; color: rgb(153, 153, 153); font-family: Arial, Helvetica, &quot;Microsoft Yahei&quot;, 微软雅黑, &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;, Tahoma, STHeiti; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);\"><span style=\"color: rgb(0, 0, 0);\">2、暖通商品<br/></span></p><p>平台甄选百余种暖通商品，确保质量可靠，售后无忧，让您的生活更美好。<br/></p><br/><p style=\"margin-top: 0px; margin-bottom: 16px; padding: 0px; line-height: 30px; color: rgb(153, 153, 153); font-family: Arial, Helvetica, &quot;Microsoft Yahei&quot;, 微软雅黑, &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;, Tahoma, STHeiti; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);\"><span style=\"color: rgb(0, 0, 0);\">3、其他服务</span></p><p style=\"margin-top: 0px; margin-bottom: 16px; padding: 0px; line-height: 30px; color: rgb(153, 153, 153); font-family: Arial, Helvetica, &quot;Microsoft Yahei&quot;, 微软雅黑, &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;, Tahoma, STHeiti; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);\"><span style=\"color: rgb(0, 0, 0);\">平台签约家政、家装服务团队，严格管理，力求为您提供优质的生活家服务。</span></p><p style=\"margin-top: 0px; margin-bottom: 16px; padding: 0px; line-height: 30px; color: rgb(153, 153, 153); font-family: Arial, Helvetica, &quot;Microsoft Yahei&quot;, 微软雅黑, &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;, Tahoma, STHeiti; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);\"><span style=\"color: rgb(0, 0, 0);\">体验过程中的任何建议，也欢迎随时反馈给我们，帮助我们做的更好！如有疑问请咨询客服400-024-0086</span></p><p><br/></p>`,
			loading: true
		};
	},
	created() {
		this.id = this.$route.path.replace('/cms/notice-', '');
		this.getDetail();
	},
	watch: {
		$route(curr) {
			this.id = curr.params.pathMatch;
			this.getDetail();
		}
	},
	methods: {
		getDetail() {
			var id = parseInt(this.id)
			console.log('this.id', typeof id)
			noticeDetail({
				id
			})
				.then(res => {
					if (res.data) {
						this.info = res.data;
						this.loading = false;
					} else {
						this.$router.push({ path: '/notice' });
					}
				})
				.catch(err => {
					this.loading = false;
					this.$message.error(err.message);
				});
		}
	}
};
</script>
<style lang="scss" scoped>
.notice-detil {
	background-color: #ffffff;
	min-height: 300px;
	margin: 10px 0;
	padding: 10px;

	.title {
		text-align: center;
		font-size: 18px;
		margin: 10px 0;
	}

	.time {
		text-align: center;
		color: #838383;
		margin-bottom: 17px;
	}

	.notice-info {
		margin: 0 43px;
		border-bottom: 1px dotted #e9e9e9;
	}

	.content {
		padding-top: 10px;
		margin: 0 65px;
	}
}

.path {
	padding: 15px 0;
}
</style>
